<template>
  <div class="page-project">
    <header class="header-default">
      <HeaderTop />
    </header>
    <div class="project-container">
      <transition name="fade" mode="out-in">
        <NuxtPage :project="project" />
      </transition>
      
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const route = useRoute();

// Примерный список проектов, возможно, лучше вынести в отдельный файл или API
const projectList = [
  {
    id: 0,
    name: "Ggwin",
    desc: "responsive, rem, gulp, PUG, SASS",
    img: "/img/port/ggwin.webp",
    link: "https://p-store.ru/ruletka2/inventar-slider.html",
    github: ""
  },
  {
    id: 1,
    name: "LilySammer",
    desc: "vue.js, vuex, webpack, PUG, SASS",
    img: "/img/port/lily.webp",
    link: "",
    github: "https://github.com/ItJustAlance/lily-kviz"
  },
  {
    id: 2,
    name: "World Wentures",
    desc: "animations",
    img: "/img/port/trans.webp",
    link: "https://p-store.ru/transplanetary/templates/sectors.html",
    github: ""
  },
  {
    id: 3,
    name: "mi-74.ru",
    desc: "design, adaptive, front-end, back-end, seo optimize, sheme.org(article, shop, contacts), the site is optimized and gives out 97 points in 'google page speed'",
    img: "/img/port/mi-74.webp",
    link: "https://mi-74.ru",
    github: ""
  },
  {
    id: 4,
    name: "lgcity.ru",
    desc: "adaptive, gulp, PUG, SASS, skeleton.js",
    img: "/img/port/lgcity.webp",
    link: "https://lgcity.ru",
    github: ""
  },
  {
    id: 5,
    name: "ford-service",
    desc: "Адаптивная верстка с калькулятором расчета стоимости ТО и взаимосвязь с бэком",
    img: "/img/port/ford.webp",
    link: "https://p-store.ru/anna-ford/"
  }
];

const projectId = Number(route.params.id); // Получаем ID из параметров маршрута
// console.log('projectId', projectId)
// Находим проект по ID
//
const project = computed(() => projectList.find(el => el.id === projectId));

// onMounted( async () => {
//   project.value = projectList.find(el => el.id === projectId);
// });

</script>

<style lang="sass">
.fade-enter-active, .fade-leave-active
  transition: opacity .5s

.fade-enter, .fade-leave-to
  opacity: 0


.project-container
  max-width: 140rem
  background: #fff
  margin: 0 auto
  text-align: center
  border-left: .1rem solid #e1e1e1
  border-right: .1rem solid #e1e1e1
  box-shadow: 0 0 .5rem rgba(126, 126, 126, .2)
.project-item
  h1
    padding: 5rem 0 2rem
    font-size: 4rem
    letter-spacing: .2rem
    color: #333333
    font-family: 'Source Sans Pro', sans-serif
  &__img
    border-top: .1rem solid #e1e1e1
    border-bottom: .1rem solid #e1e1e1
    img
      min-width: 28rem
      min-height: 28rem
  &__desc
    padding: 3rem 0
    h2
      font-size: 3rem
      color: #333
  &__links
    .link-item
      padding: .5rem
.paginations
  display: flex
  justify-content: space-between
  padding: 2rem
</style>
